import { cityLatLong } from "pages/sales-forecast/locLatLong";

export const formatNumberCard = (value: number) => {
    const numString = value.toString(); // Convert number to string
  
    if (numString.length > 6) {
      // If the number is more than 6 digits, represent it in millions (M)
      return Number(numString.slice(0, -6)).toLocaleString('en-US') + 'M';
    } else if (numString.length > 4) {
      // If the number is more than 4 digits, represent it in thousands (K)
      return Number(numString.slice(0, -3)).toLocaleString('en-US') + 'K';
    } else {
      // If it's a small number, just return it formatted normally
      return value.toLocaleString('en-US');
    }
  };

 export function formatDateCards(dateString: string): string {
    const date = new Date(dateString);
  
    // Array of month names
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
  
    // Extract day, month, and year
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear().toString().slice(-2); // Get last two digits of year
  
    return `${day} ${month}'${year}`;
  }

  export const transformCityCoordinates = (salesMapData: any) => {
    const cityHighlights = salesMapData?.map((item: any) => {
      const city = cityLatLong.find(city => city.name === item.city);
      
      if (city && city.name !== '99 WEB') {
        return {
          lat: city.lat,
          lng: city.long,
          forecast_qt: item.forecast_quantity,
          sales_qt: item.sales_quantity,
          name: city.name,
          color: "#5627D9",
        };
      }
      
      return null; // Return null if '99 WEB' or city not found
    }).filter((city: any) => city !== null); // Filter out null entries
  
    return cityHighlights;
  };